/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const FinalJudgementStep = zod
	.object({
		confidence: zod.number().describe('Final confidence score'),
		content_decision: zod.enum(['allow', 'review', 'block']),
		index: zod.number().describe('Step index within the trace'),
		kind: zod.enum(['final_judgement']),
		rationale: zod.string().nullable().describe('Agent rationale for this step')
	})
	.describe('The final judgement in the reasoning trace');

export type FinalJudgementStep = zod.input<typeof FinalJudgementStep>;
export type FinalJudgementStepOutput = zod.output<typeof FinalJudgementStep>;
